import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SuccessGuardService} from '../../shared/services/guard-services/success-guard.service';
import {HomeComponent} from './components/dashboard/home.component';
import {PersmissionGuardService} from '../../shared/services/guard-services/persmission-guard.service';

const routes: Routes = [
    {
        path: ':partner',
        component: HomeComponent,
        canActivate: [PersmissionGuardService]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [SuccessGuardService, PersmissionGuardService]
})
export class HomeRoutingModule {
}

